import React, { memo } from 'react';

export const Select = memo(function Select({
	value,
	onChange,
	options,
	placeholder,
}) {
	return (
		<div className='relative'>
			<select
				value={value ?? ''}
				onChange={(event) => onChange(event.target.value || null)}
				className='h-9 w-full appearance-none rounded-lg border border-zinc-200 bg-white px-3 pr-8 text-xs text-zinc-800 shadow-sm outline-none focus:border-sky-300 focus:ring-4 focus:ring-sky-100'
			>
				<option value=''>{placeholder}</option>
				{options.map((option) => (
					<option key={String(option.value)} value={String(option.value)}>
						{option.label}
					</option>
				))}
			</select>
			<svg
				className='pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-zinc-400'
				width='18'
				height='18'
				viewBox='0 0 20 20'
				fill='currentColor'
			>
				<path
					fillRule='evenodd'
					d='M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z'
					clipRule='evenodd'
				/>
			</svg>
		</div>
	);
});

export default Select;